import Vue from 'vue/dist/vue.min.js';
import Datepicker from 'vuejs-datepicker';
import floatingLabel from '../components/floating-label';
import getCoords from '../helpers/getcoords';
import { scroll } from '../helpers/smoothscroll';
import observer from '../libs/observer';
import { splitDateParts, transformDate } from '../helpers/date-helpers';

let defaults = {
    vueEl: '.m-form, .login-form',
    selectField: 'select',
    dateField: '.date-field > input',
    selectedClass: 'is-selected',
    errorClass: 'has-error',
    scrollDuration: 1000,
    scrollEasing: 'easeInOutCubic',
    datepicker: '.datepicker input',
    formMessageContainerAttr: 'data-form-message-container',
    allowedKeys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', '.']
};

export default (formContainerEl, options) => {
    let instance = {},
        vueInstance,
        settings = Object.assign({}, defaults, options),
        datepickers = formContainerEl.querySelectorAll(settings.datepicker),
        inputDates = {},
        setTabindex = () => {

            // Needed for navigation so that user doesn't land on this hidden field. Unfortunately, it can not be set on datepicker custom element directly.
            datepickers.forEach((datepicker) => {
                datepicker.setAttribute('tabindex', '-1');
            });
        };

    // Add composites
    Object.assign(instance, observer());

    // Check for predefined dates in date-fields
    formContainerEl.querySelectorAll(settings.dateField)
        .forEach((input) => {
            if (input.value !== '') {
                inputDates[input.id] = input.value;
            }
        });



    // Create Vue instance. we don't need to expose it to instance.
    vueInstance = new Vue({
        el: formContainerEl,
        components: {
            Datepicker
        },
        data: {
            inputDate: inputDates,
            datepickerDate: {}
        },
        methods: {
            updateInputDate(dateIndex) {
                let self = this;
                setTimeout(
                    function () {
                        floatingLabel.checkAllFields();

                        // instead of creating a custom 'blur' event and firing it
                        self.$refs['dateInput-' + dateIndex].focus();
                        self.$refs['dateInput-' + dateIndex].blur();
                    }, 50);
                this.inputDate[dateIndex] = this.$refs['datepickerRef-' + dateIndex].formattedValue;
            },

            checkValidNumber(e) {
                let pressedKey = e.key,
                    keyIsAllowed = settings.allowedKeys.indexOf(pressedKey) !== -1;

                // Prevent letters and other characters from being entered in date field
                if (!keyIsAllowed) {
                    e.preventDefault();
                }
            },

            addSelectedClass(e) {
                e.target.classList.add(settings.selectedClass);
            },

            /* eslint-disable */
            validateBeforeSubmit(e) {
                this.$validator.validateAll().then(() => {

                    // No errors - form is submitted
                    instance.trigger('submit', instance);
                }).catch((error) => {
                    // console.log('error', error);

                    let firstErrorMessage = this.$el.querySelector('.' + settings.errorClass),
                        coordTop = getCoords(firstErrorMessage).top,
                        scrollOffset;

                    // Depending on element position, the navbar is in collapsed state or not
                    // We have to take this into account
                    coordTop > 180 ? scrollOffset = -85 : scrollOffset = -160;
                    scroll(coordTop, {
                        duration: settings.scrollDuration,
                        easing: settings.scrollEasing,
                        offset: scrollOffset
                    });
                });
            },
            /* eslint-enable */

            changeLocale() {
                this.$validator.setLocale('en');
            },

            writeDatepickerDate(dateIndex) {
                let dateParts = splitDateParts(this.inputDate[dateIndex]),
                    date = transformDate(dateParts);

                this.datepickerDate[dateIndex] = new Date(date.year, date.month, date.day);
            },

            createKey(dateIndex) {
                if (!this.inputDate.hasOwnProperty(dateIndex)) {
                    Vue.set(this.inputDate, dateIndex, '');
                    Vue.set(this.datepickerDate, dateIndex, new Date());
                }
            }
        },
        created () {

            // Initial state for datepickers
            for (let d in inputDates) {
                if (inputDates.hasOwnProperty(d)) {
                    this.writeDatepickerDate(d);
                }
            }
        }
    });

    setTabindex();

    // Export element to instance, so messages can be written here.
    instance.addMessage = (content) => {
        let container = vueInstance.$el.querySelector('[' + settings.formMessageContainerAttr + ']');
        container.innerHTML = content;
    };

    instance.messagesContainer = vueInstance.$el.querySelector('[' + settings.formMessageContainerAttr + ']');
    instance.formEl = vueInstance.$refs['form'];

    return instance;
};
